import { projectUspSendHandbookAPI } from "./api";

export const getSbsProjects = async () => {
  const res = await projectUspSendHandbookAPI.getSbsProjects();
  return res?.data ?? res ?? [];
};

export const getHandbookProjects = async ({ sbs_project_id }) => {
  if (!sbs_project_id) return [];
  const res = await projectUspSendHandbookAPI.readHandbook({ sbs_project_id });
  return res?.data || [];
};

export const setUspSendEnabled = async (body) => {
  return await projectUspSendHandbookAPI.setEnabled(body);
};

export const getUspSendHistory = async (sbs_project_id) => {
  const res = await projectUspSendHandbookAPI.getHistory(sbs_project_id);
  return res?.data || [];
};

export const projectUspSendColumns = [
  { name: "sbs_project_id", field: "sbs_project_id", label: "ID", align: "center", sortable: true },
  { name: "sbs_project_name", field: "sbs_project_name", label: "Проект УСП", align: "left", sortable: true },
  { name: "is_usp_send_enabled", field: "is_usp_send_enabled", label: "Отправка в УСП", align: "center" },
  { name: "actions", field: "actions", label: "Действие", align: "center" },
];
